import enCompanyMatrix9Box from './en';
import ruCompanyMatrix9Box from './ru';

export default {
  en: {
    ...enCompanyMatrix9Box,
  },
  ru: {
    ...ruCompanyMatrix9Box,
  },
};
